import './index.scss'
import { Controller as BaseController } from 'stimulus'

export class Controller extends BaseController {
  static targets = ['self', 'cards', 'sideCards', 'cardsContainer', 'resizer', 'toggleSideBar']

  static values = {
    identifier: String
  }

  connect() {
    this.handleResize()
    if (this.hasResizerTarget) this.resizeSidebar()
  }

  resizeSidebar() {
    this.toggleSideBarTarget.addEventListener('click', (e) => {
      this.sideCardsTarget.classList.toggle('sidebar-toggle')
      if (document.querySelector('.right-arrow-nav').style.display === 'none') {
        document.querySelector('.right-arrow-nav').style.display = 'block'
        document.querySelector('.left-arrow-nav').style.display = 'none'
      } else {
        document.querySelector('.right-arrow-nav').style.display = 'none'
        document.querySelector('.left-arrow-nav').style.display = 'block'
      }
      this.sideCardsTarget.style = ''
    }, false)

    const bind = this.resize.bind(this)

    this.resizerTarget.addEventListener('mousedown', (e) => {
      document.body.classList.add('select-none')
      window.addEventListener('mousemove', bind, true)
      document.getElementsByClassName('side-bar-transition').style = ''
    }, false)

    window.addEventListener('mouseup', (e) => {
      document.body.classList.remove('select-none')
      window.removeEventListener('mousemove', bind, true)
      document.getElementsByClassName('side-bar-transition').style = 'transition: all 0.25s ease'
    }, false)
  }

  resize(e) {
    const size = `${e.x}px`
    this.sideCardsTarget.style.flexBasis = size
  }

  handleResize() {
    const smallWidth = this.selfTarget.scrollWidth < 700

    if (this.hasCardsTarget) {
      this.cardsTarget.classList.toggle('col-span-2', !smallWidth)
      this.cardsTarget.classList.toggle('col-span-3', smallWidth)
    }

    if (this.hasSideCardsTarget) {
      this.sideCardsTarget.classList.toggle('col-span-1', !smallWidth)
      this.sideCardsTarget.classList.toggle('col-span-3', smallWidth)
    }
  }
}
